import {Button, Toolbar, ToolbarItem} from "@progress/kendo-react-buttons"
import {DropDownList} from "@progress/kendo-react-dropdowns"
import {Field, FieldRenderProps, Form, FormElement, FormRenderProps} from "@progress/kendo-react-form"
import {Input} from "@progress/kendo-react-inputs"
import {useEffect, useRef, useState} from "react"
import {
    addMOTOpportunity,
    setMOTOpportunityDetail,
    setShowMotOpportunityDialog,
} from "../../containers/Activity/activitySlice"
import {FollowUpStatus, MotOpportunity, MotOpportunityInit} from "../../containers/Activity/models"

import {RootState} from "../../rootReducer"
import {SpinnerFragment} from "../../shared/CommonItems"
import {CustomCalendar} from "../../shared/CustomCalendar"
import {useAppDispatch, useAppSelector} from "../../store"
import AlertToastr from "../Shared/alertToastr"
import { Drawer } from "@volvo/vcdk-react/Drawer";
import { DrawerContent } from "@volvo/vcdk-react/DrawerContent";
import { DrawerTopBar } from "@volvo/vcdk-react/DrawerTopBar";

const MOTOpportunityAddEditModal = () => {
    const dispatch = useAppDispatch()

    const showDialog = useAppSelector((state: RootState) => state.containers.activity.showMotOpportunityDialog)
    const loadingMOTOpportunity = useAppSelector(
        (state: RootState) => state.containers.activity.loadingMotOpportunityDetail,
    )
    const motOpportunityDetail = useAppSelector((state: RootState) => state.containers.activity.motOpportunityDetail)
    const savingMOTOpportunity = useAppSelector((state: RootState) => state.containers.activity.savingMOTOpportunity)

    const userDealers = useAppSelector((state: RootState) => state.application.userDealers)

    const {dealerID} = motOpportunityDetail

    const formRef = useRef<any>()

    const [motOpportunityDetailInit, setMotOpportunityDetailInit] = useState<MotOpportunity>(motOpportunityDetail)

    useEffect(() => {
        if (showDialog && motOpportunityDetail && motOpportunityDetail?.vehicleMOTOpportunityID > 0) {
            // dispatch(fetchMotOpportunityData(bookingId))
        }
    }, [showDialog, motOpportunityDetail?.vehicleMOTOpportunityID, dispatch, motOpportunityDetail])

    const motOpportunityFormSubmitHandler = (values: any, e: any) => {
        // e.preventDefault()
        const data = values as MotOpportunity
        dispatch(addMOTOpportunity(data))
    }

    const MOTOpDealerDropdown = (fieldRenderProps: FieldRenderProps) => {
        const {onChange, label} = fieldRenderProps

        return (
            <>
                <DropDownList
                    value={userDealers.find(t => t.dealerId === dealerID)}
                    onChange={onChange}
                    textField="dealerName"
                    dataItemKey="dealerId"
                    data={userDealers}
                    label={label}
                    disabled
                />
            </>
        )
    }

    const MOTOpFollowUpStatus = (fieldRenderProps: FieldRenderProps) => {
        const {onChange, label, value} = fieldRenderProps
        return (
            <>
                <DropDownList
                    value={FollowUpStatus.find(x => x === value)}
                    onChange={onChange}
                    data={FollowUpStatus}
                    label={label}
                />
            </>
        )
    }

    const updateExipryDate = (date: Date) => {
        setMotOpportunityDetailInit({...formRef.current.values, motExpiryDate: date})
    }
    useEffect(() => {
        setMotOpportunityDetailInit(motOpportunityDetail)
    }, [motOpportunityDetail])

    useEffect(() => {
        showDialog && formRef.current?.resetForm()
    }, [showDialog])

    return (
        <>
            <AlertToastr />
            <Drawer width="500px" side="end" open={showDialog} mode="modal" onClose={() =>{ }} style={{position: "relative", zIndex: 1055}}>
                <DrawerTopBar heading= {motOpportunityDetail.vehicleMOTOpportunityID > 0 ? "MOT Opportunity":""} onClose={() => {
                    dispatch(setShowMotOpportunityDialog(false))
                    dispatch(setMOTOpportunityDetail(MotOpportunityInit()))
                }} />  
                <DrawerContent fullSize={true}>
                    <div style={{position: "relative", width: "100%", height: "100%"}}>
                        {(loadingMOTOpportunity || savingMOTOpportunity) && 
                            <div style={{position: "absolute", inset: 0, zIndex: 10, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(255,255,255,0.7)"}}>
                                <SpinnerFragment />
                            </div>
                        }
                        {showDialog && motOpportunityDetail && (
                            <Form
                                key={JSON.stringify(motOpportunityDetailInit)}
                                initialValues={motOpportunityDetailInit}
                                onSubmit={motOpportunityFormSubmitHandler}
                                ref={formRef}
                                ignoreModified
                                render={(formRenderProps: FormRenderProps) => (
                                    <FormElement className="w-100">
                                        <Toolbar className="shadow-0 border-bottom p-0 pb-1 pt-1 ps-1 position-sticky top-0">
                                            <ToolbarItem>
                                                <Button
                                                    disabled={!formRenderProps.valid}
                                                    type="submit"
                                                    fillMode="flat"
                                                    themeColor={"primary"}
                                                    iconClass="fa fa-save"
                                                >
                                                    Save
                                                </Button>
                                            </ToolbarItem>
                                        </Toolbar>
                                        <div className="modal-body modal-overflow">
                                            <fieldset className={"k-form-fieldset mt-0"}>
                                                 <div className="row">
                                                    <div className="col-md-12">
                                                        <div>Vehicle MOT Opportunity</div>
                                                        <hr className="title-hr mt-0" />
                                                        <Field
                                                            name={"dealerID"}
                                                            component={MOTOpDealerDropdown}
                                                            label={"Dealer"}
                                                        />
                                                        <Field
                                                            required
                                                            name={"registration"}
                                                            component={Input}
                                                            label={"Registration"}
                                                            disabled={motOpportunityDetail.vehicleID > 0}
                                                            tabIndex={1}
                                                        />
                                                        <Field
                                                            required
                                                            name={"motExpiryDate"}
                                                            component={CustomCalendar}
                                                            label={"MOT Expiry Date"}
                                                            tabIndex={2}
                                                            updateDate={updateExipryDate}
                                                        />
                                                        <Field
                                                            name={"customerName"}
                                                            component={Input}
                                                            label={"Contact Name"}
                                                            tabIndex={3}
                                                        />
                                                        <Field
                                                            name={"email"}
                                                            component={Input}
                                                            label={"Email"}
                                                            tabIndex={4}
                                                        />
                                                        <Field
                                                            name={"phone"}
                                                            component={Input}
                                                            label={"Phone"}
                                                            tabIndex={5}
                                                        />
                                                        <Field
                                                            name={"followUpStatus"}
                                                            component={MOTOpFollowUpStatus}
                                                            label={"Followup Status"}
                                                            value={motOpportunityDetail.followUpStatus}
                                                            tabIndex={6}
                                                        />
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </FormElement>
                                )}
                            />
                        )}
                    </div>
                </DrawerContent>
            </Drawer>
        </>
    )
}

export default MOTOpportunityAddEditModal
